import { createFileRoute } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { getActiveSupplyPoint } from '@/features/supply-points/utils/resolveActiveSupplyPoint';
import { deviceQueries } from '@/features/devices/queries';
import { CreateDevicePage } from '@/features/devices/pages/CreateDevicePage';
import { DetailsPageSkeleton } from '@/common/components/loading-skeleton/DetailsPageSkeleton';

export const Route = createFileRoute('/_authenticated/_supply-point-scope/devices/new')({
  component: CreateDevicePage,
  pendingComponent: DetailsPageSkeleton,
  loader: async ({ context: { queryClient } }) => {
    const activeSupplyPoint = await getActiveSupplyPoint(queryClient);

    if (activeSupplyPoint) {
      await Promise.all([
        queryClient.ensureQueryData(deviceQueries.list()),
        queryClient.ensureQueryData(deviceQueries.types()),
      ]);
    }

    return { breadcrumb: t`Add Device` };
  },
});
